import styled from "styled-components";

export const SidebarWrapper = styled.div`
  min-width: 232px;
  position: absolute;
  top: 0px;
  padding: 20px;
  background: linear-gradient(135deg, #1A2F3A 0%, #0F2128 100%);
  z-index: 11;
  bottom: 0;
  transition: all 0.3s;
  box-shadow: 4px 0 20px rgba(0, 0, 0, 0.1);
  
  ul {
    li {
      background: rgba(255, 255, 255, 0.05);
      border-radius: 10px;
      display: flex;
      gap: 12px;
      align-items: center;
      height: 45px;
      padding: 13px;
      color: #CCE6F5;
      margin-bottom: 10px;
      border: 1px solid rgba(45, 95, 122, 0.3);
      transition: all 0.3s ease;
      cursor: pointer;
      
      span {
        display: block;
        font-size: 14px;
        font-weight: 500;
        width: 100%;
        visibility: visible;
        opacity: 1;
        white-space: nowrap;
      }

      div {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 24px;
        height: 24px;
        
        img {
          width: 20px;
          height: 20px;
          filter: brightness(0.8) invert(0.8);
          transition: all 0.3s ease;
        }
      }

      &:hover {
        background: rgba(123, 196, 224, 0.1);
        border-color: #7BC4E0;
        transform: translateY(-2px);
        
        img {
          filter: brightness(1) invert(0);
        }
        
        span {
          color: #7BC4E0;
        }
      }

      &.active {
        background: linear-gradient(135deg, #2D5F7A 0%, #1E3B4A 100%);
        border-color: #7BC4E0;
        
        span {
          color: #FFFFFF;
          font-weight: 600;
        }
        
        img {
          filter: brightness(0) invert(1);
        }
      }
    }
  }

  &.close {
    min-width: 80px;
    width: 80px;
    overflow: hidden;
    transition: all 0.3s;
    
    ul li {
      justify-content: center;
      padding: 13px 0;
      
      span {
        visibility: hidden;
        opacity: 0;
        display: none;
      }
      
      div {
        margin: 0 auto;
      }
      
      &:hover {
        div img {
          filter: brightness(1) invert(0);
        }
      }
    }
    
    @media only screen and (max-width: 768px) {
      min-width: 232px;
      width: 232px;
      left: -244px;
      overflow: hidden;
      
      ul li {
        justify-content: start;
        padding: 13px;
        
        span {
          display: block;
          visibility: visible;
          opacity: 1;
        }
        
        div {
          margin: 0;
        }
      }
    }
  }
`;